import React from 'react'

interface Figureprops{
    path: string
    alt ?: string
}

const Figure = ({path, alt}:Figureprops) => {
    return (

        <figure className="chap-img">
        <img
          className="fill-image"
          src={path}
          alt= {alt}
        />
        </figure>
    )
}

export default Figure
